import $ from 'jquery'
import {PasswordSettingsSectionContainerConnected} from './passwordSettings/PasswordSettingsSectionContainer'
import { Product} from '../constants'
import DARSettingsSectionContainer from './darSettings/DARSettingsSectionContainer'
import {LockoutPolicyContainerConnected} from './lockoutPolicy/LockoutPolicyContainer'

export default function initGeneralSettings(product, ValidatableFormBlocks) {
    if (product === Product.actiTIME) {
        new DARSettingsSectionContainer().init($('#accessToUserInfoSettingsBlock'))
    }

    const {onModify: onPasswordSettingsModify, onSave: onPasswordSettingsSave} = ValidatableFormBlocks.register('passwordSettingsBlock')
    new PasswordSettingsSectionContainerConnected({
        onModify: onPasswordSettingsModify,
        onSave: onPasswordSettingsSave,
    }).init($('#passwordSettingsBlock'))

    const {onModify: onLockoutPolicyModify, onSave: onLockoutPolicySave} = ValidatableFormBlocks.register('lockoutPolicyBlock')
    new LockoutPolicyContainerConnected({
        onModify: onLockoutPolicyModify,
        onSave: onLockoutPolicySave,
    }).init($('#lockoutPolicyBlock'))
}



// WEBPACK FOOTER //
// ./web/js/administration/initGeneralSettings.js